/**
 * Parse FastAPI / API error bodies into safe user-facing messages.
 * Never returns sensitive payload values.
 */

export async function extractApiValidationMessage(response) {
  const body = await response.json().catch(() => null);

  if (response.status === 422 && Array.isArray(body?.detail)) {
    return body.detail
      .map((issue) => {
        const path = Array.isArray(issue.loc)
          ? issue.loc
            .filter((part) => part !== 'body')
            .join('.')
          : 'request';
        return `${path}: ${issue.msg}`;
      })
      .join('; ');
  }

  if (response.status === 422 && body?.detail && typeof body.detail === 'object') {
    const code = body.detail.error_code || body.detail.code;
    const message = body.detail.message || body.message;
    if (code && message) return `${code}: ${message}`;
    if (message) return String(message);
  }

  if (typeof body?.detail === 'string') {
    return body.detail;
  }

  return (
    body?.message
    || `Request failed with status ${response.status}`
  );
}

/**
 * Sanitized development log for validation failures.
 */
export function logSanitizedValidationError(prefix, responseStatus, message) {
  if (process.env.NODE_ENV === 'production') return;
  // eslint-disable-next-line no-console
  console.debug(prefix, {
    status: responseStatus,
    message,
  });
}
